export const CHART_COLOR_SUCCESS = 'var(--ids-sem-color-on-surface-success-muted)';
export const CHART_COLOR_WARNING = 'var(--ids-sem-color-on-surface-caution-default)';
export const CHART_COLOR_ERROR = 'var(--ids-sem-color-on-surface-error-default)';
export const getPercentageOfTotal = (content, category) => {
    const totalVehicles = content.reduce((acc, row) => acc + row.value, 0);
    const row = content.find((contentRow) => contentRow.category === category);
    return totalVehicles && row ? row.value / totalVehicles : 0;
};
const createGroupedBarChartContent = (vehicleType, formattedData) => (!formattedData || formattedData.length === 0 ? [] : [
    {
        category: '0-30',
        value: formattedData.find((contentItem) => contentItem.category === '0-30 days')?.value || 0,
        color: CHART_COLOR_SUCCESS,
    },
    {
        category: '31-45',
        value: formattedData.find((contentItem) => contentItem.category === '31-45 days')?.value || 0,
        color: vehicleType === 'New' ? CHART_COLOR_SUCCESS : CHART_COLOR_WARNING,
    },
    {
        category: '46-90',
        value: formattedData.find((contentItem) => contentItem.category === '46-90 days')?.value || 0,
        color: vehicleType === 'New' ? CHART_COLOR_WARNING : CHART_COLOR_ERROR,
    },
    {
        category: '91-120',
        value: formattedData.find((contentItem) => contentItem.category === '91-120 days')?.value || 0,
        color: vehicleType === 'New' ? CHART_COLOR_WARNING : CHART_COLOR_ERROR,
    },
    {
        category: '120+',
        value: formattedData.find((contentItem) => contentItem.category === '120+ days')?.value || 0,
        color: CHART_COLOR_ERROR,
    },
]);
export const getFormattedDaysAgedFromResponse = (response) => ({
    newVehicleTotal: response?.daysAged.reduce((accum, current) => (current.daysAtDealer !== 'Unknown' ? accum + current.newCount : accum), 0) || 0,
    cpoUsedVehicleTotal: response?.daysAged.reduce((accum, current) => (current.daysAtDealer !== 'Unknown'
        ? accum + current.usedCount + current.cpoCount
        : accum), 0) || 0,
    newVehicleFormattedData: createGroupedBarChartContent('New', ((response || {}).daysAged || []).map(({ daysAtDealer, newCount }) => ({
        category: daysAtDealer,
        value: newCount,
    }))) || [],
    usedCpoVehicleFormattedData: createGroupedBarChartContent('UsedCpo', ((response || {}).daysAged || []).map(({ daysAtDealer, usedCount, cpoCount }) => ({
        category: daysAtDealer,
        value: usedCount + cpoCount,
    }))) || [],
    lastUpdatedUTC: response?.lastUpdatedUTC || '',
});
